module.exports = {
      id: "arrow-left-usage",
      viewBox: "0 0 448 512",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#arrow-left",
      toString: function () {
        return this.url;
      }
    }